import { CommonModule } from '@angular/common';
import { Component,Input,OnDestroy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { BehaviorSubject,Subscription } from 'rxjs';
import {
CustomerEntity,
CustomerStatusEnum,
CustomerStatusTypeNames
} from '../dave-data-module/entities/customer.entity';
import { State } from '../dave-data-module/State';
import { getCustomerById } from '../dave-data-module/State/selectors/customers.selectors';

/**
 * Komponente für die Anzeige einer Betriebsstätte in einer Template Liste (z.B. dave-list-card).
 * Hinzufügt für MDQX, damit der Status einer Betriebsstätte zusätzlich angezeigt werden kann.
 */
@Component({
    selector: 'app-customer-list-entry',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, MatTooltipModule],
    templateUrl: './customer-list-entry.component.html',
    styleUrls: ['./customer-list-entry.component.scss'],
})
export class CustomerListEntryComponent implements OnDestroy {
    @Input() set Customer(c: CustomerEntity) {
        if (this.customerIdSubscription) {
            this.customerIdSubscription.unsubscribe();
        }
        this.customer$.next(c);
    }

    @Input() set CustomerId(id: number) {
        this.customerIdSubscription = this.store.select(getCustomerById({ id })).subscribe((c) => {
            this.customer$.next(c);
        });
    }

    private customerIdSubscription: Subscription = null;
    protected customer$ = new BehaviorSubject<CustomerEntity>(null);

    constructor(protected store: Store<State>) {}

    ngOnDestroy(): void {
        if (this.customerIdSubscription) {
            this.customerIdSubscription.unsubscribe();
            this.customerIdSubscription = null;
        }
    }

    protected readonly CustomerStatusTypeNames = CustomerStatusTypeNames;
    protected readonly CustomerStatusEnum = CustomerStatusEnum;
}
